/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SetPassword interface.
 */
export function instanceOfSetPassword(value) {
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
export function SetPasswordFromJSON(json) {
    return SetPasswordFromJSONTyped(json, false);
}
export function SetPasswordFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'],
    };
}
export function SetPasswordToJSON(json) {
    return SetPasswordToJSONTyped(json, false);
}
export function SetPasswordToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
    };
}
